import produce from "immer";
import { AppState } from "../../../setup/appRootReducer";
import { handleRequestActions } from "../../../framework/state/genericAsyncRequest";
import { RequestState, createInitialRequest } from "../../../framework/state/requestState";
import { RoleGroupAccessRightsDto, RoleGroupRolesDto, RoleGroups } from "../../../api";
import { roleSagas } from "../sagas/roleSagas";
import { accessRightSagas } from "../sagas/accessRightSagas";
import { CommonActions, CommonActionTypes } from "../actions/commonActions";

interface Requests {
  getRoles: RequestState<RoleGroupRolesDto[]>;
  getAccessRights: RequestState<RoleGroupAccessRightsDto[]>;
}

export interface CommonState {
  requests: Requests;
  roleGroupRoles: RoleGroupRolesDto[] | undefined;
  roleGroupAccessRights: RoleGroupAccessRightsDto[] | undefined;
  configuratorBaseUrl: string | undefined;
  applicationRoleGroup: RoleGroups | undefined;
}

const defaultState: CommonState = {
  requests: {
    getRoles: createInitialRequest(),
    getAccessRights: createInitialRequest()
  },
  roleGroupAccessRights: undefined,
  roleGroupRoles: undefined,
  configuratorBaseUrl: undefined,
  applicationRoleGroup: undefined
};

export function commonReducer(
  state: CommonState = defaultState,
  action: CommonActions
): CommonState {
  state = handleRequestActions(state, "requests", action, [
    {
      actionTypes: roleSagas.getRoles.actionTypes,
      key: "getRoles"
    },
    {
      actionTypes: accessRightSagas.getAccessRights.actionTypes,
      key: "getAccessRights"
    }
  ]);

  if (roleSagas.getRoles.isCompletedAction(action)) {
    state = produce(state, (draft) => {
      draft.roleGroupRoles = action.payload;
    });
  } else if (accessRightSagas.getAccessRights.isCompletedAction(action)) {
    state = produce(state, (draft) => {
      draft.roleGroupAccessRights = action.payload;
    });
  }

  switch (action.type) {
    case CommonActionTypes.SetConfiguratorBaseUrl:
      state = produce(state, (draft) => {
        draft.configuratorBaseUrl = action.baseUrl;
      });
      break;
    case CommonActionTypes.SetApplicationRoleGroup:
      state = produce(state, (draft) => {
        draft.applicationRoleGroup = action.roleGroup;
      });
      break;
  }

  return state;
}

export const getRoleGroupRoles = (state: AppState): RoleGroupRolesDto[] | undefined =>
  state.common.roleGroupRoles;
export const getRoleGroupAccessRights = (state: AppState): RoleGroupAccessRightsDto[] | undefined =>
  state.common.roleGroupAccessRights;

export const getConfiguratorBaseUrl = (state: AppState): string | undefined =>
  state.common.configuratorBaseUrl;

export const getApplicationRoleGroup = (state: AppState): RoleGroups | undefined =>
  state.common.applicationRoleGroup;
